import { FC } from "react";
import { Text, Line, Circle } from "react-konva";
import houseModelConfig from "utils/houseModelConfig";
import paperSize from "utils/paperSize";

type TVisionProps = {
  text?: string;
};

const fontSize = houseModelConfig.fontSize;
const lineHeight = houseModelConfig.lineHeight;
const textColor = houseModelConfig.colorGlobals[4];
const guildeCircleSize = 2;
const guildeLineColor = houseModelConfig.colorGlobals[4];
const x = paperSize.width - paperSize.width / 2.5;
const y = (paperSize.height * 33) / 100;
const w = paperSize.width / 6;
const h = fontSize * lineHeight * 6;
const guildePoints = [
  (paperSize.width * 51) / 100,
  (paperSize.height * 43) / 100,
  x - 20,
  y + fontSize / 2,
  x - 10,
  y + fontSize / 2,
];

const Vision: FC<TVisionProps> = ({ text }) => {
  if (!text) {
    return null;
  }

  return (
    <>
      <Circle
        x={guildePoints[0]}
        y={guildePoints[1]}
        radius={guildeCircleSize}
        fill={guildeLineColor}
      />
      <Circle
        x={guildePoints[4]}
        y={guildePoints[5]}
        radius={guildeCircleSize}
        fill={guildeLineColor}
      />
      <Line
        points={guildePoints}
        stroke={guildeLineColor}
        strokeWidth={1}
        lineJoin="round"
        dash={[3, 2]}
      />
      <Text
        x={x}
        y={y}
        width={w}
        height={h}
        fontSize={fontSize}
        lineHeight={lineHeight}
        text={text}
        fill={textColor}
        // stroke="white"
        // strokeWidth={2}
        // fillAfterStrokeEnabled
        // shadowColor="black"
        // shadowBlur={2}
        // shadowOffsetX={1}
        // shadowOffsetY={1}
        // shadowOpacity={0.4}
      />
    </>
  );
};

export default Vision;
